import CartFailedView from './CartFailedView';

export default CartFailedView;
